import { QueryClient } from '@tanstack/react-query';
import { bindQueryClientToSession, type SessionLifecycle } from '@mbbe/config';
import { mainMutationActivity } from './chunkRecovery';
import { customerSession, opsSession } from './sessions';

/**
 * App QueryClient whose caches are scoped to the active sessions: every
 * sign-out, account switch, role change or auth-provider unmount cancels the
 * in-flight queries and drops all cached queries and mutations.
 */
export function createAppQueryClient(sessions: SessionLifecycle[] = [opsSession, customerSession]): QueryClient {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
  sessions.forEach((session) => bindQueryClientToSession(session, queryClient));
  // An in-flight mutation keeps blocking a stale-deployment reload even after its screen was replaced.
  mainMutationActivity.attach({
    isPending: () => queryClient.isMutating() > 0,
    subscribe: (listener) => queryClient.getMutationCache().subscribe(() => listener()),
  });
  return queryClient;
}
